export const LOADING = 'LOADING';
export const FETCH_NEWS = 'FETCH_NEWS';
export const ERROR = 'ERROR';
export const SAVED = 'SAVED';
export const END_POINT = 'END_POINT';
export const SET_MODAL_DATA = 'SET_MODAL_DATA';
export const NEWS_TOPIC = 'NEWS_TOPIC';
export const TOP_NEWS = 'TOP_NEWS';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';